export default {
  TAB_EMME_RX: 'tab_emmeRx',
  TAB_INTERNAL_USER: 'tab_internal',
}